/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveBasicCostDto } from '../../models/effective-basic-cost-dto';

export interface GetEffectiveBasicCost$Params {
  id: string;
}

export function getEffectiveBasicCost(http: HttpClient, rootUrl: string, params: GetEffectiveBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveBasicCostDto>> {
  const rb = new RequestBuilder(rootUrl, getEffectiveBasicCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveBasicCostDto>;
    })
  );
}

getEffectiveBasicCost.PATH = '/v0/effectiveBasicCost/{id}';
